import { render, staticRenderFns } from "./AddTruck.vue?vue&type=template&id=799c8ebe&scoped=true"
import script from "./AddTruck.vue?vue&type=script&lang=js"
export * from "./AddTruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799c8ebe",
  null
  
)

export default component.exports